/**
 * Section-specific i18n strings merged into LanguageContext at runtime.
 * English is the source of truth for keys.
 */

export const I18N_SECTION_EN = {
  testSiteNotice: "This site is for testing only. If you see this message, please notify the site owner.",
  commonCancel: "Cancel",
  commonContinue: "Continue",
  contactHeadOfficeLabel: "Head Office",
  contactOfficeAddressLabel: "Office Address",
  contactPublicEmailLabel: "Email",
  contactPublicPhoneLabel: "Phone",
  contactHeadquartersAddressLine: "Delta Business Center B1 Block 9th Floor 18th Office Beylikdüzü / Istanbul - TURKEY",
  contactBranchAddressLine: "Kültür Street Aliçetinkaya Boulevard No 37 Başarı Building 6th Floor Alsancak / İzmir - TURKEY",
  workspaceShowcaseDemoUserName: "John Smith",
  workspaceShowcaseDemoCompanyName: "Global Foods Importers",
  procurementModelsEyebrow: "Procurement Models",
  procurementModelsTitle: "Choose How You Want To Buy From Turkey",
  procurementModelsSubtitleLine1: "Three procurement models.",
  procurementModelsSubtitleLine2: "One intelligent Workspace.",
  procurementModelsDescription: "Whether you buy one product, multiple suppliers, or bulk commodities, DeMaxtore manages the complete sourcing and import operation.",
  procurementModelsStep1Title: "Choose Your Procurement Model",
  procurementModelsStep1Text: "Select the model that fits your business needs.",
  procurementModelsStep2Title: "Receive Factory Quotations",
  procurementModelsStep2Text: "Receive multiple factory-direct quotations from verified Turkish manufacturers.",
  procurementModelsStep3Title: "Manage Everything Inside Your Workspace",
  procurementModelsStep3Text: "Manage sourcing, freight, inspection, documents and shipment visibility from one intelligent Workspace.",
  procurementModelsWorkspaceImgAlt: "Workspace dashboard",
  procurementModelsFullTagline1: "One Manufacturer.",
  procurementModelsFullTagline2: "One Product.",
  procurementModelsFullTagline3: "One Full Container.",
  procurementModelsFullFeature1: "Factory-direct purchase",
  procurementModelsFullFeature2: "One manufacturer",
  procurementModelsFullFeature3: "Best factory pricing",
  procurementModelsFullFeature4: "Perfect for repeat orders",
  procurementModelsFullCta: "Explore FullContainer →",
  procurementModelsFullImageAlt: "FullContainer – blue shipping container with DeMaxtore product boxes",
  procurementModelsSmartTagline1: "Multiple Manufacturers.",
  procurementModelsSmartTagline2: "Mixed Products.",
  procurementModelsSmartTagline3: "One Shipment.",
  procurementModelsSmartFeature1: "Factory-direct purchasing",
  procurementModelsSmartFeature2: "Multiple manufacturers",
  procurementModelsSmartFeature3: "Mixed retail products",
  procurementModelsSmartFeature4: "One consolidated shipment",
  procurementModelsSmartFeature5: "Lower logistics costs",
  procurementModelsSmartCta: "Explore SmartContainer →",
  procurementModelsSmartImageAlt: "SmartContainer – green shipping container with mixed DeMaxtore products",
  procurementModelsBulkTagline1: "Bulk Products.",
  procurementModelsBulkTagline2: "25 KG & 50 KG Bags.",
  procurementModelsBulkTagline3: "Mix Container.",
  procurementModelsBulkFeature1: "Bulk products",
  procurementModelsBulkFeature2: "Lowest logistics cost",
  procurementModelsBulkFeature3: "Ideal for distributors",
  procurementModelsBulkFeature4: "Full container loading",
  procurementModelsBulkCta: "Explore BulkContainer →",
  procurementModelsBulkImageAlt: "BulkContainer – purple shipping container with bulk product sacks",
  workspaceShowcaseBadge: "BUILT FOR IMPORTERS. DESIGNED FOR GROWTH.",
  workspaceShowcaseHeadlineLead: "The Import Operating System for Companies Sourcing From",
  workspaceShowcaseHeadlineAccent: "Turkey.",
  workspaceShowcaseLede: "Manage your sourcing, supplier collaboration, purchase orders, inspections, documents and shipment visibility in one intelligent workspace built exclusively for companies sourcing from Turkey.",
  workspaceShowcaseCta: "Create Your Free Workspace",
  workspaceShowcaseSectionTitle: "One Workspace. End-to-End Import Control.",
  workspaceShowcaseSectionSub: "From your first request to final delivery — every step of your import operation in one place.",
  workspaceShowcaseFeature1Text: "Create detailed requests and receive quotes from verified manufacturers.",
  workspaceShowcaseFeature2Text: "Run online bids and compare competitive offers transparently.",
  workspaceShowcaseFeature3Title: "Purchase Orders",
  workspaceShowcaseFeature3Text: "Create, track and manage all your purchase orders in one place.",
  workspaceShowcaseFeature4Title: "Inspection",
  workspaceShowcaseFeature4Text: "Schedule inspections and access reports before shipment.",
  workspaceShowcaseFeature5Text: "Compare rates, book freight and manage your logistics easily.",
  workspaceShowcaseFeature6Title: "Live Shipment Tracking™",
  workspaceShowcaseFeature6Text: "Track your containers in real-time with full visibility.",
  workspaceShowcaseFeature7Title: "Document Hub",
  workspaceShowcaseFeature7Text: "Store, organize and share all import documents securely.",
  workspaceShowcaseFeature8Title: "Alerts",
  workspaceShowcaseFeature8Text: "Get real-time alerts and never miss an important update.",
  commodityBidLogoAlt: "CommodityBid — Find The Best Price",
  commodityBidHeroSubtitle: "Timed Auctions. Lowest Bid Wins.",
  commodityBidHeroTagline: "Qualified Manufacturers · Equal Terms · Transparent Process",
  commodityBidHeroDescription: "Create a commodity bid, invite Qualified Manufacturers, and run a scheduled auction on equal terms. Each participant submits transparent offers in real time. When the auction ends, the lowest valid offer wins — pending your approval.",
  commodityBidCtaHeading: "Ready to run your next auction?",
  commodityBidCtaButton: "Create a CommodityBid",
  commodityBidCtaSub: "Start a timed auction and get the best market price.",
  commodityBidProcess1Title: "Create a Bid",
  commodityBidProcess1Desc: "Define commodity, quantity & terms",
  commodityBidProcess2Title: "Schedule Auction",
  commodityBidProcess2Desc: "Set start & end date/time",
  commodityBidProcess3Title: "Invite Suppliers",
  commodityBidProcess3Desc: "Send invitations to qualified suppliers",
  commodityBidProcess4Title: "Auction Starts",
  commodityBidProcess4Desc: "Live countdown begins automatically",
  commodityBidProcess5Title: "Live Offers",
  commodityBidProcess5Desc: "Qualified suppliers submit transparent bids",
  commodityBidProcess6Title: "Auction Ends",
  commodityBidProcess6Desc: "Timer expires, bidding closes",
  commodityBidProcess7Title: "Lowest Bid Wins",
  commodityBidProcess7Desc: "Winner determined automatically",
  commodityBidProcess8Title: "Share Winner",
  commodityBidProcess8Desc: "Results shared with all participants",
  commodityBidProcess9Title: "Buyer Approval",
  commodityBidProcess9Desc: "Buyer reviews and approves the winner",
  commodityBidProcess10Title: "Order Execution",
  commodityBidProcess10Desc: "Contract & delivery process begins",
  freightCargoTypeTitle: "Cargo type",
  freightCargoTypeSubtitle: "Choose category and kind of goods.",
  freightCargoTypeSectionLabel: "Cargo type",
  freightCargoTypeCategoryLabel: "Cargo category",
  freightCargoTypeKindLabel: "Cargo kind",
  freightCargoTypeSelectCategory: "Select category",
  freightCargoTypeSelectCategoryFirst: "Select category first",
  freightCargoTypeSelectKind: "Select kind",
  freightCargoTypeValidationError: "Please select both cargo category and cargo kind.",
  workspaceShowcaseSidebarWorkspace: "WORKSPACE",
  workspaceShowcaseNavOverview: "Overview",
  workspaceShowcaseNavRfqCenter: "RFQ Center",
  workspaceShowcaseNavPurchaseOrders: "Purchase Orders",
  workspaceShowcaseNavInspections: "Inspections",
  workspaceShowcaseNavShipments: "Shipments",
  workspaceShowcaseNavDocuments: "Documents",
  workspaceShowcaseNavMessages: "Messages",
  workspaceShowcaseNavAlerts: "Alerts",
  workspaceShowcaseNavReports: "Reports",
  workspaceShowcaseNavSettings: "Settings",
  workspaceShowcaseWelcomeBack: "Welcome back, John",
  workspaceShowcaseWelcomeSub: "Here's what's happening with your import operations.",
  workspaceShowcaseDemoDateRange: "May 12 – Jun 12, 2024",
  workspaceShowcaseStatActiveRfqs: "Active RFQs",
  workspaceShowcaseStatActiveRfqsTrend: "3 new updates",
  workspaceShowcaseStatOffersReceived: "Offers Received",
  workspaceShowcaseStatOffersReceivedTrend: "5 new offers",
  workspaceShowcaseStatOrdersInProgress: "Orders in Progress",
  workspaceShowcaseStatOrdersInProgressTrend: "2 in production",
  workspaceShowcaseStatShipmentsInTransit: "Shipments in Transit",
  workspaceShowcaseStatShipmentsInTransitTrend: "2 on the way",
  workspaceShowcaseRecentActivityTitle: "Recent Activity",
  workspaceShowcaseActivity1Title: "New offer received",
  workspaceShowcaseActivity1Subtitle: "Anatolia Gıda San. A.Ş.",
  workspaceShowcaseActivity2Title: "PO #PO-2024-1187 confirmed",
  workspaceShowcaseActivity2Subtitle: "Ege Yağ ve Gıda A.Ş.",
  workspaceShowcaseActivity3Title: "Inspection report uploaded",
  workspaceShowcaseActivity3Subtitle: "Trakya Un Fabrikası",
  workspaceShowcaseActivity4Title: "Shipment departed",
  workspaceShowcaseActivity4Subtitle: "MSC Mediterranean Shipping",
  workspaceShowcaseActivity5Title: "New RFQ submitted",
  workspaceShowcaseActivity5Subtitle: "Konya Plastik A.Ş.",
  workspaceShowcaseActivity6Title: "Quality check passed",
  workspaceShowcaseActivity6Subtitle: "Demak Tekstil Ltd.",
  workspaceShowcaseViewAllActivity: "View All Activity",
  workspaceShowcaseMilestonesTitle: "Upcoming Milestones",
  workspaceShowcaseMilestone1Title: "Inspection scheduled",
  workspaceShowcaseMilestone1Subtitle: "PO #PO-2024-1189",
  workspaceShowcaseMilestone1Date: "May 15",
  workspaceShowcaseMilestone2Title: "Production completion",
  workspaceShowcaseMilestone2Subtitle: "PO #PO-2024-1187",
  workspaceShowcaseMilestone2Date: "May 18",
  workspaceShowcaseMilestone3Title: "Vessel departure",
  workspaceShowcaseMilestone3Subtitle: "MSC AB123E",
  workspaceShowcaseMilestone3Date: "May 20",
  workspaceShowcaseMilestone4Title: "Estimated arrival",
  workspaceShowcaseMilestone4Subtitle: "Lagos, Nigeria",
  workspaceShowcaseMilestone4Date: "May 29",
  workspaceShowcaseMilestone5Title: "Document submission",
  workspaceShowcaseMilestone5Subtitle: "PO #PO-2024-1190",
  workspaceShowcaseMilestone5Date: "Jun 2",
  workspaceShowcaseMilestone6Title: "Customs clearance",
  workspaceShowcaseMilestone6Subtitle: "Lagos Port Authority",
  workspaceShowcaseMilestone6Date: "Jun 5",
  workspaceShowcaseViewAllMilestones: "View All Milestones",
  workspaceShowcaseShipmentTrackingTitle: "Shipment Tracking",
  workspaceShowcaseMapRewind: "Rewind",
  workspaceShowcaseMapPlay: "Play",
  workspaceShowcaseMapPause: "Pause",
  workspaceShowcaseMapStatusPaused: "Paused",
  workspaceShowcaseMapStatusLive: "Live",
  workspaceShowcaseDemoVesselId: "MSC AB123E",
  workspaceShowcaseStatusInTransit: "In Transit",
  workspaceShowcaseEtaLabel: "ETA:",
  workspaceShowcaseDemoEtaDate: "May 29, 2024",
  workspaceShowcaseTrackShipment: "Track Shipment",
  commodityBidDemoCommodity: "Sunflower Oil",
  commodityBidDemoCommodityMeta: "100 MT • CIF Hamburg, Germany",
  commodityBidDemoContractValue: "Est. contract value {amount}",
  commodityBidDemoStatusLive: "Live",
  commodityBidDemoStatusClosed: "Closed",
  commodityBidDemoResponsesLabel: "Responses",
  commodityBidDemoResponsesValue: "8 Manufacturers",
  commodityBidDemoClosesIn: "Auction closes in",
  commodityBidDemoClosed: "Auction closed",
  commodityBidDemoLowestBid: "Lowest valid bid",
  commodityBidDemoPerMt: "/ MT",
  commodityBidDemoSavings: "Savings {amount} · {percent}%",
  commodityBidDemoManufacturerName: "Manufacturer #{number}",
  commodityBidDemoSupplierBadge: "Qualified · Verified",
  commodityBidDemoWinner: "Winner",
  commodityBidDemoFooterLive: "Offers update in real time as qualified suppliers participate",
  commodityBidDemoFooterClosed: "Lowest valid bid identified · awaiting buyer approval",
  commodityBidDemoReplay: "Replay",
};

export const I18N_SECTION_FR = {
  testSiteNotice: "Ce site est réservé aux tests. Si vous voyez ce message, veuillez en informer le propriétaire du site.",
  commonCancel: "Annuler",
  commonContinue: "Continuer",
  contactHeadOfficeLabel: "Siège social",
  contactOfficeAddressLabel: "Adresse du bureau",
  contactPublicEmailLabel: "E-mail",
  contactPublicPhoneLabel: "Téléphone",
  contactHeadquartersAddressLine: "Delta Business Center, bloc B1, 9e étage, bureau 18, Beylikdüzü / Istanbul - TURQUIE",
  contactBranchAddressLine: "Kültür Street, boulevard Aliçetinkaya, bâtiment Başarı, 6e étage, Alsancak / Izmir - TURQUIE",
  workspaceShowcaseDemoUserName: "John Smith",
  workspaceShowcaseDemoCompanyName: "Global Foods Importers",
  procurementModelsEyebrow: "Modèles d'approvisionnement",
  procurementModelsTitle: "Choisissez comment acheter depuis la Turquie",
  procurementModelsSubtitleLine1: "Trois modèles d'approvisionnement.",
  procurementModelsSubtitleLine2: "Un Workspace intelligent.",
  procurementModelsDescription: "Que vous achetiez un seul produit, plusieurs fournisseurs ou des matières en vrac, DeMaxtore gère l'ensemble de l'opération d'approvisionnement et d'importation.",
  procurementModelsStep1Title: "Choisissez votre modèle d'approvisionnement",
  procurementModelsStep1Text: "Sélectionnez le modèle adapté à votre activité.",
  procurementModelsStep2Title: "Recevez des devis usine",
  procurementModelsStep2Text: "Recevez plusieurs devis directs d'usines auprès de fabricants turcs vérifiés.",
  procurementModelsStep3Title: "Gérez tout dans votre Workspace",
  procurementModelsStep3Text: "Gérez l'approvisionnement, le fret, l'inspection, les documents et la visibilité des expéditions depuis un Workspace intelligent.",
  procurementModelsWorkspaceImgAlt: "Tableau de bord Workspace",
  procurementModelsFullTagline1: "Un fabricant.",
  procurementModelsFullTagline2: "Un produit.",
  procurementModelsFullTagline3: "Un conteneur complet.",
  procurementModelsFullFeature1: "Achat direct usine",
  procurementModelsFullFeature2: "Un fabricant",
  procurementModelsFullFeature3: "Meilleur prix usine",
  procurementModelsFullFeature4: "Idéal pour les commandes récurrentes",
  procurementModelsFullCta: "Explorer FullContainer →",
  procurementModelsFullImageAlt: "FullContainer – conteneur bleu avec cartons DeMaxtore",
  procurementModelsSmartTagline1: "Plusieurs fabricants.",
  procurementModelsSmartTagline2: "Produits mixtes.",
  procurementModelsSmartTagline3: "Une expédition.",
  procurementModelsSmartFeature1: "Achats directs usine",
  procurementModelsSmartFeature2: "Plusieurs fabricants",
  procurementModelsSmartFeature3: "Produits de détail mixtes",
  procurementModelsSmartFeature4: "Une expédition consolidée",
  procurementModelsSmartFeature5: "Coûts logistiques réduits",
  procurementModelsSmartCta: "Explorer SmartContainer →",
  procurementModelsSmartImageAlt: "SmartContainer – conteneur vert avec produits DeMaxtore mixtes",
  procurementModelsBulkTagline1: "Produits en vrac.",
  procurementModelsBulkTagline2: "Sacs de 25 kg et 50 kg.",
  procurementModelsBulkTagline3: "Conteneur mixte.",
  procurementModelsBulkFeature1: "Produits en vrac",
  procurementModelsBulkFeature2: "Coût logistique le plus bas",
  procurementModelsBulkFeature3: "Idéal pour les distributeurs",
  procurementModelsBulkFeature4: "Chargement conteneur complet",
  procurementModelsBulkCta: "Explorer BulkContainer →",
  procurementModelsBulkImageAlt: "BulkContainer – conteneur violet avec sacs en vrac",
  workspaceShowcaseBadge: "CONÇU POUR LES IMPORTATEURS. PENSÉ POUR LA CROISSANCE.",
  workspaceShowcaseHeadlineLead: "Le système d'exploitation import pour les entreprises qui s'approvisionnent en",
  workspaceShowcaseHeadlineAccent: "Turquie.",
  workspaceShowcaseLede: "Gérez votre approvisionnement, la collaboration fournisseurs, les bons de commande, les inspections, les documents et la visibilité des expéditions dans un espace de travail intelligent conçu pour les entreprises qui s'approvisionnent en Turquie.",
  workspaceShowcaseCta: "Créer votre Workspace gratuit",
  workspaceShowcaseSectionTitle: "Un Workspace. Contrôle import de bout en bout.",
  workspaceShowcaseSectionSub: "De votre première demande à la livraison finale — chaque étape de votre opération d'import au même endroit.",
  workspaceShowcaseFeature1Text: "Créez des demandes détaillées et recevez des devis de fabricants vérifiés.",
  workspaceShowcaseFeature2Text: "Lancez des enchères en ligne et comparez les offres en toute transparence.",
  workspaceShowcaseFeature3Title: "Bons de commande",
  workspaceShowcaseFeature3Text: "Créez, suivez et gérez tous vos bons de commande au même endroit.",
  workspaceShowcaseFeature4Title: "Inspection",
  workspaceShowcaseFeature4Text: "Planifiez des inspections et consultez les rapports avant l'expédition.",
  workspaceShowcaseFeature5Text: "Comparez les tarifs, réservez le fret et gérez votre logistique facilement.",
  workspaceShowcaseFeature6Title: "Live Shipment Tracking™",
  workspaceShowcaseFeature6Text: "Suivez vos conteneurs en temps réel avec une visibilité complète.",
  workspaceShowcaseFeature7Title: "Document Hub",
  workspaceShowcaseFeature7Text: "Stockez, organisez et partagez tous vos documents d'import en toute sécurité.",
  workspaceShowcaseFeature8Title: "Alertes",
  workspaceShowcaseFeature8Text: "Recevez des alertes en temps réel et ne manquez aucune mise à jour importante.",
  commodityBidLogoAlt: "CommodityBid — Trouvez le meilleur prix",
  commodityBidHeroSubtitle: "Enchères chronométrées. La meilleure offre l'emporte.",
  commodityBidHeroTagline: "Fabricants qualifiés · Conditions égales · Processus transparent",
  commodityBidHeroDescription: "Créez une enchère matière première, invitez des fabricants qualifiés et lancez une vente programmée à conditions égales. Chaque participant soumet des offres transparentes en temps réel. À la fin, l'offre valide la plus basse l'emporte — sous réserve de votre approbation.",
  commodityBidCtaHeading: "Prêt à lancer votre prochaine enchère ?",
  commodityBidCtaButton: "Créer une CommodityBid",
  commodityBidCtaSub: "Lancez une enchère chronométrée et obtenez le meilleur prix du marché.",
  commodityBidProcess1Title: "Créer une enchère",
  commodityBidProcess1Desc: "Définir matière, quantité et conditions",
  commodityBidProcess2Title: "Programmer l'enchère",
  commodityBidProcess2Desc: "Définir date et heure de début et de fin",
  commodityBidProcess3Title: "Inviter les fournisseurs",
  commodityBidProcess3Desc: "Envoyer des invitations aux fournisseurs qualifiés",
  commodityBidProcess4Title: "Début de l'enchère",
  commodityBidProcess4Desc: "Le compte à rebours démarre automatiquement",
  commodityBidProcess5Title: "Offres en direct",
  commodityBidProcess5Desc: "Les fournisseurs qualifiés soumettent des offres transparentes",
  commodityBidProcess6Title: "Fin de l'enchère",
  commodityBidProcess6Desc: "Le minuteur expire, les offres sont closes",
  commodityBidProcess7Title: "La meilleure offre l'emporte",
  commodityBidProcess7Desc: "Le gagnant est déterminé automatiquement",
  commodityBidProcess8Title: "Partager le gagnant",
  commodityBidProcess8Desc: "Résultats partagés avec tous les participants",
  commodityBidProcess9Title: "Approbation acheteur",
  commodityBidProcess9Desc: "L'acheteur examine et approuve le gagnant",
  commodityBidProcess10Title: "Exécution de la commande",
  commodityBidProcess10Desc: "Le contrat et la livraison démarrent",
  freightCargoTypeTitle: "Type de marchandise",
  freightCargoTypeSubtitle: "Choisissez la catégorie et le type de marchandises.",
  freightCargoTypeSectionLabel: "Type de marchandise",
  freightCargoTypeCategoryLabel: "Catégorie",
  freightCargoTypeKindLabel: "Type",
  freightCargoTypeSelectCategory: "Sélectionner une catégorie",
  freightCargoTypeSelectCategoryFirst: "Sélectionnez d'abord une catégorie",
  freightCargoTypeSelectKind: "Sélectionner un type",
  freightCargoTypeValidationError: "Veuillez sélectionner la catégorie et le type de marchandise.",
  workspaceShowcaseSidebarWorkspace: "WORKSPACE",
  workspaceShowcaseNavOverview: "Vue d'ensemble",
  workspaceShowcaseNavRfqCenter: "Centre de demandes de devis",
  workspaceShowcaseNavPurchaseOrders: "Bons de commande",
  workspaceShowcaseNavInspections: "Inspections",
  workspaceShowcaseNavShipments: "Expéditions",
  workspaceShowcaseNavDocuments: "Documents",
  workspaceShowcaseNavMessages: "Messages",
  workspaceShowcaseNavAlerts: "Alertes",
  workspaceShowcaseNavReports: "Rapports",
  workspaceShowcaseNavSettings: "Paramètres",
  workspaceShowcaseWelcomeBack: "Bon retour, John",
  workspaceShowcaseWelcomeSub: "Voici ce qui se passe dans vos opérations d'import.",
  workspaceShowcaseDemoDateRange: "12 mai – 12 juin 2024",
  workspaceShowcaseStatActiveRfqs: "Demandes de devis actives",
  workspaceShowcaseStatActiveRfqsTrend: "3 nouvelles mises à jour",
  workspaceShowcaseStatOffersReceived: "Offres reçues",
  workspaceShowcaseStatOffersReceivedTrend: "5 nouvelles offres",
  workspaceShowcaseStatOrdersInProgress: "Commandes en cours",
  workspaceShowcaseStatOrdersInProgressTrend: "2 en production",
  workspaceShowcaseStatShipmentsInTransit: "Expéditions en transit",
  workspaceShowcaseStatShipmentsInTransitTrend: "2 en route",
  workspaceShowcaseRecentActivityTitle: "Activité récente",
  workspaceShowcaseActivity1Title: "Nouvelle offre reçue",
  workspaceShowcaseActivity1Subtitle: "Anatolia Gıda San. A.Ş.",
  workspaceShowcaseActivity2Title: "Bon de commande #PO-2024-1187 confirmé",
  workspaceShowcaseActivity2Subtitle: "Ege Yağ ve Gıda A.Ş.",
  workspaceShowcaseActivity3Title: "Rapport d'inspection ajouté",
  workspaceShowcaseActivity3Subtitle: "Trakya Un Fabrikası",
  workspaceShowcaseActivity4Title: "Expédition partie",
  workspaceShowcaseActivity4Subtitle: "MSC Mediterranean Shipping",
  workspaceShowcaseActivity5Title: "Nouvelle demande de devis envoyée",
  workspaceShowcaseActivity5Subtitle: "Konya Plastik A.Ş.",
  workspaceShowcaseActivity6Title: "Contrôle qualité validé",
  workspaceShowcaseActivity6Subtitle: "Demak Tekstil Ltd.",
  workspaceShowcaseViewAllActivity: "Voir toute l'activité",
  workspaceShowcaseMilestonesTitle: "Prochaines étapes",
  workspaceShowcaseMilestone1Title: "Inspection programmée",
  workspaceShowcaseMilestone1Subtitle: "PO #PO-2024-1189",
  workspaceShowcaseMilestone1Date: "15 mai",
  workspaceShowcaseMilestone2Title: "Fin de production",
  workspaceShowcaseMilestone2Subtitle: "PO #PO-2024-1187",
  workspaceShowcaseMilestone2Date: "18 mai",
  workspaceShowcaseMilestone3Title: "Départ du navire",
  workspaceShowcaseMilestone3Subtitle: "MSC AB123E",
  workspaceShowcaseMilestone3Date: "20 mai",
  workspaceShowcaseMilestone4Title: "Arrivée estimée",
  workspaceShowcaseMilestone4Subtitle: "Lagos, Nigeria",
  workspaceShowcaseMilestone4Date: "29 mai",
  workspaceShowcaseMilestone5Title: "Soumission des documents",
  workspaceShowcaseMilestone5Subtitle: "PO #PO-2024-1190",
  workspaceShowcaseMilestone5Date: "2 juin",
  workspaceShowcaseMilestone6Title: "Dédouanement",
  workspaceShowcaseMilestone6Subtitle: "Autorité portuaire de Lagos",
  workspaceShowcaseMilestone6Date: "5 juin",
  workspaceShowcaseViewAllMilestones: "Voir toutes les étapes",
  workspaceShowcaseShipmentTrackingTitle: "Suivi d'expédition",
  workspaceShowcaseMapRewind: "Revenir au début",
  workspaceShowcaseMapPlay: "Lecture",
  workspaceShowcaseMapPause: "Pause",
  workspaceShowcaseMapStatusPaused: "En pause",
  workspaceShowcaseMapStatusLive: "En direct",
  workspaceShowcaseDemoVesselId: "MSC AB123E",
  workspaceShowcaseStatusInTransit: "En transit",
  workspaceShowcaseEtaLabel: "ETA :",
  workspaceShowcaseDemoEtaDate: "29 mai 2024",
  workspaceShowcaseTrackShipment: "Suivre l’expédition",
  commodityBidDemoCommodity: "Huile de tournesol",
  commodityBidDemoCommodityMeta: "100 MT • CIF Hambourg, Allemagne",
  commodityBidDemoContractValue: "Valeur estimée du contrat {amount}",
  commodityBidDemoStatusLive: "En direct",
  commodityBidDemoStatusClosed: "Clôturé",
  commodityBidDemoResponsesLabel: "Réponses",
  commodityBidDemoResponsesValue: "8 fabricants",
  commodityBidDemoClosesIn: "Clôture de l'enchère dans",
  commodityBidDemoClosed: "Enchère clôturée",
  commodityBidDemoLowestBid: "Meilleure offre valide",
  commodityBidDemoPerMt: "/ MT",
  commodityBidDemoSavings: "Économies {amount} · {percent}%",
  commodityBidDemoManufacturerName: "Fabricant n° {number}",
  commodityBidDemoSupplierBadge: "Qualifié · Vérifié",
  commodityBidDemoWinner: "Gagnant",
  commodityBidDemoFooterLive: "Les offres évoluent en temps réel avec la participation des fournisseurs qualifiés",
  commodityBidDemoFooterClosed: "Meilleure offre valide identifiée · en attente d'approbation acheteur",
  commodityBidDemoReplay: "Rejouer",
};

export const I18N_SECTION_ES = {
  testSiteNotice: "Este sitio es solo para pruebas. Si ve este mensaje, notifique al propietario del sitio.",
  commonCancel: "Cancelar",
  commonContinue: "Continuar",
  contactHeadOfficeLabel: "Oficina central",
  contactOfficeAddressLabel: "Dirección de oficina",
  contactPublicEmailLabel: "Correo electrónico",
  contactPublicPhoneLabel: "Teléfono",
  contactHeadquartersAddressLine: "Delta Business Center, bloque B1, 9.º piso, oficina 18, Beylikdüzü / Estambul - TURQUÍA",
  contactBranchAddressLine: "Calle Kültür, bulevar Aliçetinkaya, edificio Başarı, 6.º piso, Alsancak / Esmirna - TURQUÍA",
  workspaceShowcaseDemoUserName: "John Smith",
  workspaceShowcaseDemoCompanyName: "Global Foods Importers",
  procurementModelsEyebrow: "Modelos de abastecimiento",
  procurementModelsTitle: "Elija cómo comprar desde Turquía",
  procurementModelsSubtitleLine1: "Tres modelos de abastecimiento.",
  procurementModelsSubtitleLine2: "Un Workspace inteligente.",
  procurementModelsDescription: "Ya sea un solo producto, varios proveedores o materias a granel, DeMaxtore gestiona toda la operación de abastecimiento e importación.",
  procurementModelsStep1Title: "Elija su modelo de abastecimiento",
  procurementModelsStep1Text: "Seleccione el modelo que se adapte a su negocio.",
  procurementModelsStep2Title: "Reciba cotizaciones de fábrica",
  procurementModelsStep2Text: "Reciba varias cotizaciones directas de fábrica de fabricantes turcos verificados.",
  procurementModelsStep3Title: "Gestione todo en su Workspace",
  procurementModelsStep3Text: "Gestione abastecimiento, flete, inspección, documentos y visibilidad de envíos desde un Workspace inteligente.",
  procurementModelsWorkspaceImgAlt: "Panel de Workspace",
  procurementModelsFullTagline1: "Un fabricante.",
  procurementModelsFullTagline2: "Un producto.",
  procurementModelsFullTagline3: "Un contenedor completo.",
  procurementModelsFullFeature1: "Compra directa de fábrica",
  procurementModelsFullFeature2: "Un fabricante",
  procurementModelsFullFeature3: "Mejor precio de fábrica",
  procurementModelsFullFeature4: "Ideal para pedidos recurrentes",
  procurementModelsFullCta: "Explorar FullContainer →",
  procurementModelsFullImageAlt: "FullContainer – contenedor azul con cajas de productos DeMaxtore",
  procurementModelsSmartTagline1: "Varios fabricantes.",
  procurementModelsSmartTagline2: "Productos mixtos.",
  procurementModelsSmartTagline3: "Un envío.",
  procurementModelsSmartFeature1: "Compras directas de fábrica",
  procurementModelsSmartFeature2: "Varios fabricantes",
  procurementModelsSmartFeature3: "Productos minoristas mixtos",
  procurementModelsSmartFeature4: "Un envío consolidado",
  procurementModelsSmartFeature5: "Menores costes logísticos",
  procurementModelsSmartCta: "Explorar SmartContainer →",
  procurementModelsSmartImageAlt: "SmartContainer – contenedor verde con productos mixtos de DeMaxtore",
  procurementModelsBulkTagline1: "Productos a granel.",
  procurementModelsBulkTagline2: "Sacos de 25 kg y 50 kg.",
  procurementModelsBulkTagline3: "Contenedor mixto.",
  procurementModelsBulkFeature1: "Productos a granel",
  procurementModelsBulkFeature2: "Menor coste logístico",
  procurementModelsBulkFeature3: "Ideal para distribuidores",
  procurementModelsBulkFeature4: "Carga de contenedor completo",
  procurementModelsBulkCta: "Explorar BulkContainer →",
  procurementModelsBulkImageAlt: "BulkContainer – contenedor morado con sacos de productos a granel",
  workspaceShowcaseBadge: "DISEÑADO PARA IMPORTADORES. CREADO PARA CRECER.",
  workspaceShowcaseHeadlineLead: "El sistema operativo de importación para empresas que abastecen desde",
  workspaceShowcaseHeadlineAccent: "Turquía.",
  workspaceShowcaseLede: "Gestione su abastecimiento, colaboración con proveedores, órdenes de compra, inspecciones, documentos y visibilidad de envíos en un espacio de trabajo inteligente diseñado para empresas que abastecen desde Turquía.",
  workspaceShowcaseCta: "Cree su Workspace gratuito",
  workspaceShowcaseSectionTitle: "Un Workspace. Control de importación de extremo a extremo.",
  workspaceShowcaseSectionSub: "Desde su primera solicitud hasta la entrega final: cada paso de su operación de importación en un solo lugar.",
  workspaceShowcaseFeature1Text: "Cree solicitudes detalladas y reciba cotizaciones de fabricantes verificados.",
  workspaceShowcaseFeature2Text: "Lance subastas en línea y compare ofertas competitivas con transparencia.",
  workspaceShowcaseFeature3Title: "Órdenes de compra",
  workspaceShowcaseFeature3Text: "Cree, haga seguimiento y gestione todas sus órdenes de compra en un solo lugar.",
  workspaceShowcaseFeature4Title: "Inspección",
  workspaceShowcaseFeature4Text: "Programe inspecciones y acceda a informes antes del envío.",
  workspaceShowcaseFeature5Text: "Compare tarifas, reserve flete y gestione su logística con facilidad.",
  workspaceShowcaseFeature6Title: "Live Shipment Tracking™",
  workspaceShowcaseFeature6Text: "Rastree sus contenedores en tiempo real con visibilidad total.",
  workspaceShowcaseFeature7Title: "Document Hub",
  workspaceShowcaseFeature7Text: "Almacene, organice y comparta todos sus documentos de importación de forma segura.",
  workspaceShowcaseFeature8Title: "Alertas",
  workspaceShowcaseFeature8Text: "Reciba alertas en tiempo real y no se pierda ninguna actualización importante.",
  commodityBidLogoAlt: "CommodityBid — Encuentre el mejor precio",
  commodityBidHeroSubtitle: "Subastas cronometradas. Gana la oferta más baja.",
  commodityBidHeroTagline: "Fabricantes cualificados · Condiciones iguales · Proceso transparente",
  commodityBidHeroDescription: "Cree una subasta de materias primas, invite a fabricantes cualificados y ejecute una venta programada en igualdad de condiciones. Cada participante envía ofertas transparentes en tiempo real. Al finalizar, la oferta válida más baja gana, pendiente de su aprobación.",
  commodityBidCtaHeading: "¿Listo para su próxima subasta?",
  commodityBidCtaButton: "Crear una CommodityBid",
  commodityBidCtaSub: "Inicie una subasta cronometrada y obtenga el mejor precio de mercado.",
  commodityBidProcess1Title: "Crear una subasta",
  commodityBidProcess1Desc: "Defina materia, cantidad y condiciones",
  commodityBidProcess2Title: "Programar subasta",
  commodityBidProcess2Desc: "Establezca fecha y hora de inicio y fin",
  commodityBidProcess3Title: "Invitar proveedores",
  commodityBidProcess3Desc: "Envíe invitaciones a proveedores cualificados",
  commodityBidProcess4Title: "Inicio de la subasta",
  commodityBidProcess4Desc: "La cuenta atrás comienza automáticamente",
  commodityBidProcess5Title: "Ofertas en vivo",
  commodityBidProcess5Desc: "Los proveedores cualificados envían ofertas transparentes",
  commodityBidProcess6Title: "Fin de la subasta",
  commodityBidProcess6Desc: "El temporizador expira y cierra las ofertas",
  commodityBidProcess7Title: "Gana la oferta más baja",
  commodityBidProcess7Desc: "El ganador se determina automáticamente",
  commodityBidProcess8Title: "Compartir ganador",
  commodityBidProcess8Desc: "Resultados compartidos con todos los participantes",
  commodityBidProcess9Title: "Aprobación del comprador",
  commodityBidProcess9Desc: "El comprador revisa y aprueba al ganador",
  commodityBidProcess10Title: "Ejecución del pedido",
  commodityBidProcess10Desc: "Comienzan el contrato y la entrega",
  freightCargoTypeTitle: "Tipo de carga",
  freightCargoTypeSubtitle: "Elija la categoría y el tipo de mercancía.",
  freightCargoTypeSectionLabel: "Tipo de carga",
  freightCargoTypeCategoryLabel: "Categoría",
  freightCargoTypeKindLabel: "Tipo",
  freightCargoTypeSelectCategory: "Seleccionar categoría",
  freightCargoTypeSelectCategoryFirst: "Seleccione primero una categoría",
  freightCargoTypeSelectKind: "Seleccionar tipo",
  freightCargoTypeValidationError: "Seleccione la categoría y el tipo de mercancía.",
  workspaceShowcaseSidebarWorkspace: "WORKSPACE",
  workspaceShowcaseNavOverview: "Vista general",
  workspaceShowcaseNavRfqCenter: "Centro de solicitudes de cotización",
  workspaceShowcaseNavPurchaseOrders: "Órdenes de compra",
  workspaceShowcaseNavInspections: "Inspecciones",
  workspaceShowcaseNavShipments: "Envíos",
  workspaceShowcaseNavDocuments: "Documentos",
  workspaceShowcaseNavMessages: "Mensajes",
  workspaceShowcaseNavAlerts: "Alertas",
  workspaceShowcaseNavReports: "Informes",
  workspaceShowcaseNavSettings: "Configuración",
  workspaceShowcaseWelcomeBack: "Bienvenido de nuevo, John",
  workspaceShowcaseWelcomeSub: "Esto es lo que ocurre en sus operaciones de importación.",
  workspaceShowcaseDemoDateRange: "12 may – 12 jun 2024",
  workspaceShowcaseStatActiveRfqs: "Solicitudes de cotización activas",
  workspaceShowcaseStatActiveRfqsTrend: "3 nuevas actualizaciones",
  workspaceShowcaseStatOffersReceived: "Ofertas recibidas",
  workspaceShowcaseStatOffersReceivedTrend: "5 nuevas ofertas",
  workspaceShowcaseStatOrdersInProgress: "Órdenes en curso",
  workspaceShowcaseStatOrdersInProgressTrend: "2 en producción",
  workspaceShowcaseStatShipmentsInTransit: "Envíos en tránsito",
  workspaceShowcaseStatShipmentsInTransitTrend: "2 en camino",
  workspaceShowcaseRecentActivityTitle: "Actividad reciente",
  workspaceShowcaseActivity1Title: "Nueva oferta recibida",
  workspaceShowcaseActivity1Subtitle: "Anatolia Gıda San. A.Ş.",
  workspaceShowcaseActivity2Title: "Orden de compra #PO-2024-1187 confirmada",
  workspaceShowcaseActivity2Subtitle: "Ege Yağ ve Gıda A.Ş.",
  workspaceShowcaseActivity3Title: "Informe de inspección cargado",
  workspaceShowcaseActivity3Subtitle: "Trakya Un Fabrikası",
  workspaceShowcaseActivity4Title: "Envío salió del puerto",
  workspaceShowcaseActivity4Subtitle: "MSC Mediterranean Shipping",
  workspaceShowcaseActivity5Title: "Nueva solicitud de cotización enviada",
  workspaceShowcaseActivity5Subtitle: "Konya Plastik A.Ş.",
  workspaceShowcaseActivity6Title: "Control de calidad aprobado",
  workspaceShowcaseActivity6Subtitle: "Demak Tekstil Ltd.",
  workspaceShowcaseViewAllActivity: "Ver toda la actividad",
  workspaceShowcaseMilestonesTitle: "Próximos hitos",
  workspaceShowcaseMilestone1Title: "Inspección programada",
  workspaceShowcaseMilestone1Subtitle: "PO #PO-2024-1189",
  workspaceShowcaseMilestone1Date: "15 may",
  workspaceShowcaseMilestone2Title: "Finalización de producción",
  workspaceShowcaseMilestone2Subtitle: "PO #PO-2024-1187",
  workspaceShowcaseMilestone2Date: "18 may",
  workspaceShowcaseMilestone3Title: "Salida del buque",
  workspaceShowcaseMilestone3Subtitle: "MSC AB123E",
  workspaceShowcaseMilestone3Date: "20 may",
  workspaceShowcaseMilestone4Title: "Llegada estimada",
  workspaceShowcaseMilestone4Subtitle: "Lagos, Nigeria",
  workspaceShowcaseMilestone4Date: "29 may",
  workspaceShowcaseMilestone5Title: "Envío de documentos",
  workspaceShowcaseMilestone5Subtitle: "PO #PO-2024-1190",
  workspaceShowcaseMilestone5Date: "2 jun",
  workspaceShowcaseMilestone6Title: "Despacho aduanero",
  workspaceShowcaseMilestone6Subtitle: "Autoridad Portuaria de Lagos",
  workspaceShowcaseMilestone6Date: "5 jun",
  workspaceShowcaseViewAllMilestones: "Ver todos los hitos",
  workspaceShowcaseShipmentTrackingTitle: "Seguimiento de envío",
  workspaceShowcaseMapRewind: "Reiniciar",
  workspaceShowcaseMapPlay: "Reproducir",
  workspaceShowcaseMapPause: "Pausar",
  workspaceShowcaseMapStatusPaused: "Pausado",
  workspaceShowcaseMapStatusLive: "En vivo",
  workspaceShowcaseDemoVesselId: "MSC AB123E",
  workspaceShowcaseStatusInTransit: "En tránsito",
  workspaceShowcaseEtaLabel: "ETA:",
  workspaceShowcaseDemoEtaDate: "29 may 2024",
  workspaceShowcaseTrackShipment: "Rastrear el envío",
  commodityBidDemoCommodity: "Aceite de girasol",
  commodityBidDemoCommodityMeta: "100 MT • CIF Hamburgo, Alemania",
  commodityBidDemoContractValue: "Valor estimado del contrato {amount}",
  commodityBidDemoStatusLive: "En vivo",
  commodityBidDemoStatusClosed: "Cerrado",
  commodityBidDemoResponsesLabel: "Respuestas",
  commodityBidDemoResponsesValue: "8 fabricantes",
  commodityBidDemoClosesIn: "La subasta cierra en",
  commodityBidDemoClosed: "Subasta cerrada",
  commodityBidDemoLowestBid: "Oferta válida más baja",
  commodityBidDemoPerMt: "/ MT",
  commodityBidDemoSavings: "Ahorro {amount} · {percent}%",
  commodityBidDemoManufacturerName: "Fabricante #{number}",
  commodityBidDemoSupplierBadge: "Cualificado · Verificado",
  commodityBidDemoWinner: "Ganador",
  commodityBidDemoFooterLive: "Las ofertas se actualizan en tiempo real mientras participan proveedores cualificados",
  commodityBidDemoFooterClosed: "Oferta válida más baja identificada · pendiente de aprobación del comprador",
  commodityBidDemoReplay: "Repetir",
};

export const I18N_SECTION_AR = {
  testSiteNotice: "هذا الموقع للاختبار فقط. إذا ظهرت لك هذه الرسالة، يرجى إبلاغ مالك الموقع.",
  commonCancel: "إلغاء",
  commonContinue: "متابعة",
  contactHeadOfficeLabel: "المكتب الرئيسي",
  contactOfficeAddressLabel: "عنوان المكتب",
  contactPublicEmailLabel: "البريد الإلكتروني",
  contactPublicPhoneLabel: "الهاتف",
  contactHeadquartersAddressLine: "مركز دلتا للأعمال، بلوك B1، الطابق التاسع، مكتب رقم 18، بيليك دوزو / إسطنبول - تركيا",
  contactBranchAddressLine: "شارع كولتور، جادة علي جتينكايا، مبنى باشاري، الطابق السادس، ألسنجاك / إزمير - تركيا",
  workspaceShowcaseDemoUserName: "John Smith",
  workspaceShowcaseDemoCompanyName: "Global Foods Importers",
  procurementModelsEyebrow: "نماذج التوريد",
  procurementModelsTitle: "اختر كيف تشتري من تركيا",
  procurementModelsSubtitleLine1: "ثلاثة نماذج توريد.",
  procurementModelsSubtitleLine2: "Workspace ذكي واحد.",
  procurementModelsDescription: "سواء اشتريت منتجًا واحدًا أو عدة موردين أو سلعًا بالجملة، تدير DeMaxtore عملية التوريد والاستيراد بالكامل.",
  procurementModelsStep1Title: "اختر نموذج التوريد",
  procurementModelsStep1Text: "حدد النموذج المناسب لعملك.",
  procurementModelsStep2Title: "استلم عروض أسعار المصنع",
  procurementModelsStep2Text: "استلم عدة عروض مباشرة من مصنعين أتراك موثوقين.",
  procurementModelsStep3Title: "أدر كل شيء داخل Workspace",
  procurementModelsStep3Text: "أدر التوريد والشحن والتفتيش والمستندات وتتبع الشحنات من Workspace ذكي واحد.",
  workspaceShowcaseBadge: "صُمم للمستوردين. وبُني للنمو.",
  workspaceShowcaseHeadlineLead: "نظام تشغيل الاستيراد للشركات التي تورد من",
  workspaceShowcaseHeadlineAccent: "تركيا.",
  workspaceShowcaseCta: "أنشئ Workspace مجانيًا",
  workspaceShowcaseSectionTitle: "Workspace واحد. تحكم كامل في الاستيراد.",
  commodityBidHeroSubtitle: "مزادات موقوتة. أقل عرض يفوز.",
  commodityBidCtaButton: "إنشاء CommodityBid",
  freightCargoTypeTitle: "نوع البضاعة",
  procurementModelsWorkspaceImgAlt: "لوحة Workspace",
  procurementModelsFullTagline1: "مصنع واحد.",
  procurementModelsFullTagline2: "منتج واحد.",
  procurementModelsFullTagline3: "حاوية كاملة واحدة.",
  procurementModelsFullFeature1: "شراء مباشر من المصنع",
  procurementModelsFullFeature2: "مصنع واحد",
  procurementModelsFullFeature3: "أفضل سعر من المصنع",
  procurementModelsFullFeature4: "مثالي للطلبات المتكررة",
  procurementModelsFullCta: "استكشف FullContainer →",
  procurementModelsFullImageAlt: "FullContainer – حاوية شحن زرقاء مع صناديق منتجات DeMaxtore",
  procurementModelsSmartTagline1: "عدة مصنعين.",
  procurementModelsSmartTagline2: "منتجات مختلطة.",
  procurementModelsSmartTagline3: "شحنة واحدة.",
  procurementModelsSmartFeature1: "شراء مباشر من المصنع",
  procurementModelsSmartFeature2: "عدة مصنعين",
  procurementModelsSmartFeature3: "منتجات تجزئة مختلطة",
  procurementModelsSmartFeature4: "شحنة موحدة واحدة",
  procurementModelsSmartFeature5: "تكاليف لوجستية أقل",
  procurementModelsSmartCta: "استكشف SmartContainer →",
  procurementModelsSmartImageAlt: "SmartContainer – حاوية شحن خضراء مع منتجات DeMaxtore مختلطة",
  procurementModelsBulkTagline1: "منتجات بالجملة.",
  procurementModelsBulkTagline2: "أكياس 25 كغ و50 كغ.",
  procurementModelsBulkTagline3: "حاوية مختلطة.",
  procurementModelsBulkFeature1: "منتجات بالجملة",
  procurementModelsBulkFeature2: "أقل تكلفة لوجستية",
  procurementModelsBulkFeature3: "مثالي للموزعين",
  procurementModelsBulkFeature4: "تحميل حاوية كاملة",
  procurementModelsBulkCta: "استكشف BulkContainer →",
  procurementModelsBulkImageAlt: "BulkContainer – حاوية شحن بنفسجية مع أكياس منتجات بالجملة",
  workspaceShowcaseLede: "أدر التوريد والتعاون مع الموردين وأوامر الشراء والتفتيش والمستندات وتتبع الشحنات في مساحة عمل ذكية مصممة للشركات التي تورد من تركيا.",
  workspaceShowcaseSectionSub: "من أول طلب حتى التسليم النهائي — كل خطوة في عملية الاستيراد في مكان واحد.",
  workspaceShowcaseFeature1Text: "أنشئ طلبات مفصلة واستلم عروض أسعار من مصنعين موثوقين.",
  workspaceShowcaseFeature2Text: "نفّذ مزادات عبر الإنترنت وقارن العروض التنافسية بشفافية.",
  workspaceShowcaseFeature3Title: "أوامر الشراء",
  workspaceShowcaseFeature3Text: "أنشئ وتتبع وأدر جميع أوامر الشراء في مكان واحد.",
  workspaceShowcaseFeature4Title: "التفتيش",
  workspaceShowcaseFeature4Text: "جدول التفتيش واطلع على التقارير قبل الشحن.",
  workspaceShowcaseFeature5Text: "قارن الأسعار واحجز الشحن وأدر اللوجستيات بسهولة.",
  workspaceShowcaseFeature6Title: "Live Shipment Tracking™",
  workspaceShowcaseFeature6Text: "تتبع حاوياتك في الوقت الفعلي مع رؤية كاملة.",
  workspaceShowcaseFeature7Title: "Document Hub",
  workspaceShowcaseFeature7Text: "خزّن ونظّم وشارك جميع مستندات الاستيراد بأمان.",
  workspaceShowcaseFeature8Title: "التنبيهات",
  workspaceShowcaseFeature8Text: "احصل على تنبيهات فورية ولا تفوّت أي تحديث مهم.",
  commodityBidLogoAlt: "CommodityBid — اعثر على أفضل سعر",
  commodityBidHeroTagline: "مصنعون مؤهلون · شروط متساوية · عملية شفافة",
  commodityBidHeroDescription: "أنشئ مزادًا للسلع، وادعُ مصنعين مؤهلين، ونفّذ مزادًا مجدولًا بشروط متساوية. يقدم كل مشارك عروضًا شفافة في الوقت الفعلي. عند الانتهاء، يفوز أقل عرض صالح — بانتظار موافقتك.",
  commodityBidCtaHeading: "هل أنت مستعد لتشغيل مزادك التالي؟",
  commodityBidCtaSub: "ابدأ مزادًا موقوتًا واحصل على أفضل سعر في السوق.",
  commodityBidProcess1Title: "إنشاء مزاد",
  commodityBidProcess1Desc: "حدد السلعة والكمية والشروط",
  commodityBidProcess2Title: "جدولة المزاد",
  commodityBidProcess2Desc: "حدد تاريخ ووقت البداية والنهاية",
  commodityBidProcess3Title: "دعوة الموردين",
  commodityBidProcess3Desc: "أرسل دعوات إلى موردين مؤهلين",
  commodityBidProcess4Title: "بدء المزاد",
  commodityBidProcess4Desc: "يبدأ العد التنازلي تلقائيًا",
  commodityBidProcess5Title: "عروض مباشرة",
  commodityBidProcess5Desc: "يقدم الموردون المؤهلون عروضًا شفافة",
  commodityBidProcess6Title: "انتهاء المزاد",
  commodityBidProcess6Desc: "ينتهي المؤقت وتُغلق العروض",
  commodityBidProcess7Title: "أقل عرض يفوز",
  commodityBidProcess7Desc: "يُحدد الفائز تلقائيًا",
  commodityBidProcess8Title: "مشاركة الفائز",
  commodityBidProcess8Desc: "تُشارك النتائج مع جميع المشاركين",
  commodityBidProcess9Title: "موافقة المشتري",
  commodityBidProcess9Desc: "يراجع المشتري الفائز ويوافق عليه",
  commodityBidProcess10Title: "تنفيذ الطلب",
  commodityBidProcess10Desc: "تبدأ عملية العقد والتسليم",
  freightCargoTypeSubtitle: "اختر فئة ونوع البضاعة.",
  freightCargoTypeSectionLabel: "نوع البضاعة",
  freightCargoTypeCategoryLabel: "الفئة",
  freightCargoTypeKindLabel: "النوع",
  freightCargoTypeSelectCategory: "اختر الفئة",
  freightCargoTypeSelectCategoryFirst: "اختر الفئة أولًا",
  freightCargoTypeSelectKind: "اختر النوع",
  freightCargoTypeValidationError: "يرجى اختيار فئة ونوع البضاعة.",
  workspaceShowcaseSidebarWorkspace: "WORKSPACE",
  workspaceShowcaseNavOverview: "نظرة عامة",
  workspaceShowcaseNavRfqCenter: "مركز طلبات عروض الأسعار",
  workspaceShowcaseNavPurchaseOrders: "أوامر الشراء",
  workspaceShowcaseNavInspections: "التفتيش",
  workspaceShowcaseNavShipments: "الشحنات",
  workspaceShowcaseNavDocuments: "المستندات",
  workspaceShowcaseNavMessages: "الرسائل",
  workspaceShowcaseNavAlerts: "التنبيهات",
  workspaceShowcaseNavReports: "التقارير",
  workspaceShowcaseNavSettings: "الإعدادات",
  workspaceShowcaseWelcomeBack: "مرحبًا بعودتك، John",
  workspaceShowcaseWelcomeSub: "هذا ما يحدث في عمليات الاستيراد الخاصة بك.",
  workspaceShowcaseDemoDateRange: "12 مايو – 12 يونيو 2024",
  workspaceShowcaseStatActiveRfqs: "طلبات عروض أسعار نشطة",
  workspaceShowcaseStatActiveRfqsTrend: "3 تحديثات جديدة",
  workspaceShowcaseStatOffersReceived: "العروض المستلمة",
  workspaceShowcaseStatOffersReceivedTrend: "5 عروض جديدة",
  workspaceShowcaseStatOrdersInProgress: "أوامر قيد التنفيذ",
  workspaceShowcaseStatOrdersInProgressTrend: "2 قيد الإنتاج",
  workspaceShowcaseStatShipmentsInTransit: "شحنات قيد النقل",
  workspaceShowcaseStatShipmentsInTransitTrend: "2 في الطريق",
  workspaceShowcaseRecentActivityTitle: "النشاط الأخير",
  workspaceShowcaseActivity1Title: "تم استلام عرض جديد",
  workspaceShowcaseActivity1Subtitle: "Anatolia Gıda San. A.Ş.",
  workspaceShowcaseActivity2Title: "تم تأكيد أمر الشراء #PO-2024-1187",
  workspaceShowcaseActivity2Subtitle: "Ege Yağ ve Gıda A.Ş.",
  workspaceShowcaseActivity3Title: "تم رفع تقرير التفتيش",
  workspaceShowcaseActivity3Subtitle: "Trakya Un Fabrikası",
  workspaceShowcaseActivity4Title: "غادرت الشحنة",
  workspaceShowcaseActivity4Subtitle: "MSC Mediterranean Shipping",
  workspaceShowcaseActivity5Title: "تم إرسال طلب عرض سعر جديد",
  workspaceShowcaseActivity5Subtitle: "Konya Plastik A.Ş.",
  workspaceShowcaseActivity6Title: "تم اجتياز فحص الجودة",
  workspaceShowcaseActivity6Subtitle: "Demak Tekstil Ltd.",
  workspaceShowcaseViewAllActivity: "عرض كل النشاط",
  workspaceShowcaseMilestonesTitle: "المراحل القادمة",
  workspaceShowcaseMilestone1Title: "تمت جدولة التفتيش",
  workspaceShowcaseMilestone1Subtitle: "PO #PO-2024-1189",
  workspaceShowcaseMilestone1Date: "15 مايو",
  workspaceShowcaseMilestone2Title: "اكتمال الإنتاج",
  workspaceShowcaseMilestone2Subtitle: "PO #PO-2024-1187",
  workspaceShowcaseMilestone2Date: "18 مايو",
  workspaceShowcaseMilestone3Title: "مغادرة السفينة",
  workspaceShowcaseMilestone3Subtitle: "MSC AB123E",
  workspaceShowcaseMilestone3Date: "20 مايو",
  workspaceShowcaseMilestone4Title: "الوصول المتوقع",
  workspaceShowcaseMilestone4Subtitle: "لاغوس، نيجيريا",
  workspaceShowcaseMilestone4Date: "29 مايو",
  workspaceShowcaseMilestone5Title: "تقديم المستندات",
  workspaceShowcaseMilestone5Subtitle: "PO #PO-2024-1190",
  workspaceShowcaseMilestone5Date: "2 يونيو",
  workspaceShowcaseMilestone6Title: "التخليص الجمركي",
  workspaceShowcaseMilestone6Subtitle: "هيئة ميناء لاغوس",
  workspaceShowcaseMilestone6Date: "5 يونيو",
  workspaceShowcaseViewAllMilestones: "عرض كل المراحل",
  workspaceShowcaseShipmentTrackingTitle: "تتبع الشحنة",
  workspaceShowcaseMapRewind: "إعادة",
  workspaceShowcaseMapPlay: "تشغيل",
  workspaceShowcaseMapPause: "إيقاف مؤقت",
  workspaceShowcaseMapStatusPaused: "متوقف مؤقتًا",
  workspaceShowcaseMapStatusLive: "مباشر",
  workspaceShowcaseDemoVesselId: "MSC AB123E",
  workspaceShowcaseStatusInTransit: "قيد النقل",
  workspaceShowcaseEtaLabel: "ETA:",
  workspaceShowcaseDemoEtaDate: "29 مايو 2024",
  workspaceShowcaseTrackShipment: "تتبع الشحنة",
  commodityBidDemoCommodity: "زيت دوار الشمس",
  commodityBidDemoCommodityMeta: "100 MT • CIF هامبورغ، ألمانيا",
  commodityBidDemoContractValue: "القيمة التقديرية للعقد {amount}",
  commodityBidDemoStatusLive: "مباشر",
  commodityBidDemoStatusClosed: "مغلق",
  commodityBidDemoResponsesLabel: "الردود",
  commodityBidDemoResponsesValue: "8 مصنعين",
  commodityBidDemoClosesIn: "ينتهي المزاد خلال",
  commodityBidDemoClosed: "انتهى المزاد",
  commodityBidDemoLowestBid: "أقل عرض صالح",
  commodityBidDemoPerMt: "/ MT",
  commodityBidDemoSavings: "توفير {amount} · {percent}%",
  commodityBidDemoManufacturerName: "الشركة المصنعة #{number}",
  commodityBidDemoSupplierBadge: "مؤهل · موثق",
  commodityBidDemoWinner: "الفائز",
  commodityBidDemoFooterLive: "تتحدث العروض فورياً مع مشاركة الموردين المؤهلين",
  commodityBidDemoFooterClosed: "تم تحديد أقل عرض صالح · بانتظار موافقة المشتري",
  commodityBidDemoReplay: "إعادة العرض",
};
